<template>
  <span>
    <a-tooltip>
    <template slot="title">
      <b>Wiki:</b> modal desplegable de información sobre la pestaña actual.
    </template>

    <a-icon type="question-circle"
            theme="twoTone"
            @click="showModal"
    />
    </a-tooltip>
    <a-modal :width="width"
             v-model="visible"
             title="Wiki"
             :footer="null"
             @ok="handleOk">
      <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="Información">
        <span class="scroll-wiki" v-html="wikiResponse && wikiResponse.value"></span>
          <slot name="customText">
          </slot>
      </a-tab-pane>
      <a-tab-pane key="2" force-render>
        <span slot="tab">
          Notas
        </span>

          <div>
            <a-spin tip="Cargando..." :spinning="spinning">
          <a-list
            v-if="comments.length"
            :data-source="comments"
            item-layout="horizontal"
            class="scroll-wiki"
          >
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-comment
                :author="item.created_by"
                :content="item.comment"
                :datetime="item.created_on"
              />
            </a-list-item>
          </a-list>
          <a-comment>
            <div slot="content">
              <a-form-item>
                <a-textarea placeholder="Digite su nota a guardar." :rows="4" :value="value" @change="handleChange" @keyup.enter="handleSubmit"/>
              </a-form-item>
              <a-form-item>
                <a-button html-type="submit" :loading="submitting" type="primary" @click="handleSubmit">
                  Enviar nota.
                </a-button>
              </a-form-item>
            </div>
          </a-comment>
            </a-spin>
        </div>

      </a-tab-pane>
      </a-tabs>
    </a-modal>
  </span>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    props: {
      keyValue: {
        type: String
      },
      width: {
        type: String,
        default: '100%'
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.getWikiValue()
    },
    data () {
      return {
        visible: false,
        comments: [],
        submitting: false,
        value: '',
        wikiResponse: null,
        spinning: false
      }
    },
    methods: {
      getWikiValue () {
        if (!this.$isEmpty(this.keyValue)) {
          this.httpClient.getInstance().get('wiki_gbpo/' + this.keyValue)
            .then(response => {
              this.wikiResponse = response.data
              this.getComments()
            }).catch((error) => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'Wiki no configurada.'))
            })
        }
      },
      getComments () {
        if (!this.$isEmpty(this.wikiResponse)) {
          this.spinning = true
          this.httpClient.getInstance().get('wiki_comments/' + this.wikiResponse.id)
            .then(response => {
              this.comments = response.data
            }).catch((error) => {
              Mensajes.error('Error', this.$getErrorMessage(error, 'Error obteniendo comentarios.'))
            }).then(() => {
              this.spinning = false
            })
        }
      },
      handleSubmit (event) {
        if (event.shiftKey === true && event.key === 'Enter') {
          return
        }
        if (!this.value) {
          return
        }
        this.submitting = true
        let req = {
          id_wiki: this.wikiResponse.id,
          comment: this.value
        }
        this.httpClient.getInstance().post('wiki_comment', req)
          .then(response => {
            this.comments = [
              response.data,
              ...this.comments
            ]
          }).catch((error) => {
            Mensajes.error('Error', this.$getErrorMessage(error, 'Error obteniendo comentarios.'))
          }).then(() => {
            this.submitting = false
            this.value = ''
          })
      },
      showModal () {
        this.visible = true
      },
      handleOk (e) {
        this.visible = false
      },
      handleChange (e) {
        this.value = e.target.value
      }
    }
  }
</script>

<style scoped>
  .header-btn {
    margin-right: 8px !important;
    margin-bottom: 12px !important;
  }

  .scroll-wiki {
    text-align: justify;
    text-justify: inter-word;
    max-height: 200px !important;
    overflow-y: auto
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/wiki.vue